<template>
  <div>
    <el-dialog :visible="visible" title="关联发票信息" width="1200px" :show-close="false">
      <div>
        <el-form class="zg-table-form" :model="tableFormModel" ref="tableForm">
          <el-table :data="invoiceList">
            <el-table-column label="发票代码" prop="invoiceCode" align="center" width="150">
              <template slot="header">
                <span class="is-required">发票代码</span>
              </template>
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`list.${$index}.invoiceCode`" :rules="normalValidator">
                  <el-input
                    v-model.trim="row.invoiceCode"
                    @input="inputHandler(row, 'invoiceCode', 'string', 'number', 12)"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="发票号码" prop="invoiceNumber" align="center" width="150">
              <template slot="header">
                <span class="is-required">发票号码</span>
              </template>
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`list.${$index}.invoiceNumber`" :rules="normalValidator">
                  <el-input
                    v-model.trim="row.invoiceNumber"
                    @input="inputHandler(row, 'invoiceNumber', 'string', 'number', 8)"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="invoiceDate" width="160" align="center">
              <template slot="header">
                <span class="is-required">开票日期</span>
              </template>
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`list.${$index}.invoiceDate`" :rules="normalValidator">
                  <el-date-picker
                    v-model="row.invoiceDate"
                    format="yyyy-MM-dd"
                    style="width: 100%"
                    value-format="timestamp"
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="totalTaxAmount" align="center" width="150">
              <template slot="header">
                <span class="is-required">价税合计金额</span>
              </template>
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`list.${$index}.totalTaxAmount`" :rules="normalValidator">
                  <el-input v-model="row.totalTaxAmount"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="invoiceAmount" align="center" width="150">
              <template slot="header">
                <span class="is-required">不含税金额</span>
              </template>
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`list.${$index}.totalTaxAmount`" :rules="normalValidator">
                  <el-input v-model="row.invoiceAmount"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="快递单号" prop="expressTrackingNum" align="center" width="150">
              <template v-slot="{ row }">
                <el-input v-model="row.expressTrackingNum"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="快递公司" prop="expressCompany" align="center" width="150">
              <template v-slot="{ row, $index }">
                <el-select
                  :value="row.expressCompanyCode"
                  @change="changeExpressCompany($event, $index)"
                  filterable
                  placeholder="请选择快递公司"
                >
                  <el-option
                    v-for="express in expressCompanies"
                    :value="express.value"
                    :label="express.label"
                    :key="express.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="附件" prop="attachmentFileKey" align="center" width="150">
              <template v-slot="{ row }">
                <el-tag
                  closable
                  v-for="(file, index) in row.attachmentFileKey"
                  :key="index"
                  @close="row.attachmentFileKey.splice(index, 1)"
                >
                  <span class="annex-name">{{ file.name }}</span>
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="120">
              <template v-slot="{ $index }">
                <el-button type="text" size="small" @click="addAnnex($index)">附件上传</el-button>
                <el-button type="text" size="small" @click="deleteRow($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="add-button">
          <el-button type="text" @click="addNewRow">新增</el-button>
        </div>
      </div>
      <template #footer>
        <div>
          <el-button @click="$emit('update:visible', false)">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </template>
    </el-dialog>
    <upload-invoice-dialog
      ref="uploadDialog"
      :row-index="curRowIndex"
      @confirm="handleConfirmUploadDialog"
    >
    </upload-invoice-dialog>
  </div>
</template>

<script>
import { formatMoney } from 'common/filters'
import UploadInvoiceDialog from './uploadInvoiceDialog'

const defaultInvoice = {
  invoiceCode: '',
  invoiceNumber: '',
  invoiceDate: '',
  totalTaxAmount: '',
  invoiceAmount: '',
  expressTrackingNum: '',
  expressCompany: '',
  expressCompanyCode: '',
  attachmentFileKey: []
}

export default {
  name: 'invoice-editor',
  components: {
    UploadInvoiceDialog
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    invoice: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    // 重新开始输入
    refresh: {
      type: Boolean,
      default: false
    },
    ignore: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      invoiceList: [],
      expressCompanies: [],
      curRowIndex: 0,
      normalValidator: {
        validator: (rule, val, callback) => {
          // 数据不允许为空
          if (val === '') {
            return callback(new Error(''))
          } else if (val === undefined) {
            return callback(new Error(''))
          } else if (val === '-') {
            return callback(new Error(''))
          }

          let keys = rule.field.split('.')
          if (keys[2] === 'invoiceCode') {
            if (
              !(
                this.invoiceList[keys[1]][keys[2]].length >= 10 &&
                this.invoiceList[keys[1]][keys[2]].length <= 12
              )
            ) {
              return callback(new Error(''))
            }
          }

          if (keys[2] === 'invoiceNumber') {
            if (!(this.invoiceList[keys[1]][keys[2]].length === 8)) {
              return callback(new Error(''))
            }
          }

          callback()
        }
      }
    }
  },
  computed: {
    tableFormModel() {
      return { list: this.invoiceList }
    }
  },
  async created() {
    let { success, data } = await this.$get('invoice.common.queryExpressCompany')
    if (success) {
      this.expressCompanies = data[0].expressCompanys.map(i => ({
        label: i.comName,
        value: i.comCode
      }))
    }
  },
  mounted() {
    this.reset(this.refresh)
  },
  watch: {
    invoice(val) {
      this.reset(this.refresh)
    },
    visible(val) {
      this.reset(this.refresh || !val)
    }
  },
  methods: {
    // 阻止发票号码、发票代码输入非数字
    inputHandler(row, key, validateType, stringType, stringLength) {
      if (validateType === 'string') {
        if (stringType === 'number') {
          this.$set(row, key, row[key].replace(/[^\d]/g, ''))
        }
        this.$set(row, key, row[key].slice(0, stringLength))
      }
    },
    async confirm() {
      // 在校验前检测是否存在不合规范的发票号码/代码，给出提示
      if (
        !this.invoiceList.every(i => {
          return (i.invoiceNumber || '').length === 8
        })
      ) {
        this.$message.warning('发票号码必须是 8 位')
      } else if (
        !this.invoiceList.every(i => {
          return (i.invoiceCode || '').length >= 10 && (i.invoiceCode || '').length <= 12
        })
      ) {
        this.$message.warning('发票代码必须是 10 ~ 12 位')
      }

      const res = await this.$refs.tableForm.validate().catch(e => e)
      if (!res) return false

      // 当前必填字段：发票号码，发票代码
      const checkFields = ['invoiceCode', 'invoiceNumber', 'invoiceDate']
      // 确保都填写完整了
      if (
        this.invoiceList.every(invoice => {
          return checkFields.every(i => !!invoice[i])
        })
      ) {
        // 在填写废弃后的重新录入时，检验是否已经存在已有的发票号码
        let checkData = this.invoiceList

        // 检测当前输入的发票中是否有重复(发票号码唯一)
        const checkInvoiceNumber = checkData.filter(i => !!i.invoiceNumber)
        if (
          checkInvoiceNumber.length !== new Set(checkInvoiceNumber.map(i => i.invoiceNumber)).size
        ) {
          this.$message.warning('存在重复的发票号码， 请核对')
          return false
        }
        // 在填写废弃后的重新录入时，检验是否已经存在已有的发票号码，但可以和被废弃的那条重复
        if (
          this.refresh &&
          this.invoiceList.some(invoice => {
            if (this.ignore.indexOf(invoice.invoiceNumber) > -1) return false
            return this.invoice.some(i => i.invoiceNumber === invoice.invoiceNumber)
          })
        ) {
          this.$message.warning('您输入的发票与申请单中已有的发票信息有重复，请核对')
          return false
        }

        if (
          checkData.map(x => x.totalTaxAmount).filter(Boolean).length !== checkData.length ||
          checkData.map(x => x.invoiceAmount).filter(Boolean).length !== checkData.length
        ) {
          this.$message.warning('含税金额和不含税金额不能为空')
          return false
        }
        if (
          !checkData
            .map(x => x.totalTaxAmount)
            .concat(checkData.map(x => x.totalTaxAmount))
            .every(i => i === '--') &&
          (checkData.map(x => +x.totalTaxAmount).includes(NaN) ||
            checkData.map(x => +x.invoiceAmount).includes(NaN))
        ) {
          this.$message.warning('金额必须为数值类型')
          return false
        }
        // 价税合计金额必须大于不含税金额金额
        const inValidData = checkData.filter(
          ({ totalTaxAmount, invoiceAmount }) =>
            totalTaxAmount && invoiceAmount && +totalTaxAmount <= +invoiceAmount
        )
        if (inValidData.length) {
          this.$message.warning('价税合计金额必须大于不含税金额')
          return false
        }

        this.$emit(
          'finish',
          JSON.parse(
            JSON.stringify(
              this.invoiceList.map(x => ({
                ...x,
                totalTaxAmount: +x.totalTaxAmount * 100 || 0,
                invoiceAmount: +x.invoiceAmount * 100 || 0
              }))
            )
          )
        )
        // 提交修改过的信息
      } else {
        this.$message.warning('请填写完整的发票信息')
      }
    },
    deleteRow(rowIndex) {
      this.invoiceList.splice(rowIndex, 1)
    },
    addNewRow() {
      this.invoiceList.push({ ...defaultInvoice })
    },
    addAnnex(index) {
      this.curRowIndex = index
      this.$refs.uploadDialog.visible = true
      if (
        this.invoiceList[index] &&
        this.invoiceList[index].attachmentFileKey &&
        this.invoiceList[index].attachmentFileKey.length
      ) {
        this.$refs.uploadDialog.fileList = this.invoiceList[index].attachmentFileKey.map(x => ({
          ...x,
          fk: x.fileKey
        }))
      }
    },
    handleConfirmUploadDialog(data = {}) {
      const { fileList = [], rowIndex = 0 } = data
      this.$set(this.invoiceList[rowIndex], 'attachmentFileKey', fileList)
    },
    // 选取快递公司
    changeExpressCompany(code, index) {
      let option = this.expressCompanies.find(i => i.value === code)
      this.invoiceList[index].expressCompany = option.label
      this.invoiceList[index].expressCompanyCode = code
    },
    reset(refresh = false) {
      if (refresh) {
        this.invoiceList = []
      } else {
        this.invoiceList = JSON.parse(
          JSON.stringify(
            this.invoice.map(x => ({
              ...x,
              totalTaxAmount: formatMoney(+x.totalTaxAmount / 100) || '--',
              invoiceAmount: formatMoney(+x.invoiceAmount / 100) || '--'
            }))
          )
        )
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.add-button
  text-align center
  padding-top 10px
.annex-name
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
>>>.el-tag__close.el-icon-close
  top: -10px;
>>>.el-table__header
  .is-required
    &:before
      content '*'
      color #F56C6C
      margin-right 4px
</style>
